import ErrMsg from "../../HBMessage/errMsg";
const rules = {
  title: [
    {
      message: <ErrMsg>请输入画板标题</ErrMsg>,
      validator(_, value) {
        if (typeof value === "string") {
          if (value.trim()) {
            return Promise.resolve();
          } else {
            return Promise.reject();
          }
        }
      },
    },
    {
      max: 32,
      message: <ErrMsg>不能超过32个字符</ErrMsg>,
    },
  ],
  description: [
    {
      max: 255,
      message: <ErrMsg>不能超过255个字符</ErrMsg>,
    },
  ],
  category: [],
  collection_id: [],
};

export default rules;
